import React, { useCallback, useState, useEffect, useMemo, useRef } from 'react';

import 'react-tabs/style/react-tabs.css';

import { getMovimentoProfile } from '../../profiles/getMovimentoProfile';

import { useActionLock } from '../../../../../hooks/useActionLock';

/* padronização dos forms MODULES */
import { useCabecalhoModule } from '../modules/useCabecalhoModule';
import { useBalancoModule } from '../modules/useBalancoModule';
import { useItensModule } from '../modules/useItensModule';
import { useAssinaturasModule } from '../modules/useAssinaturasModule';

import { useFreteModule } from '../modules/useFreteModule';
import { useAditivoModule } from '../modules/useAditivoModule';
import { usePedidoPadraoModule } from '../modules/usePedidoPadraoModule';
import { useDistribuicaoFiscalModule } from '../modules/distribuicaoFiscal/useDistribuicaoFiscalModule';
/* TABS PANEL */
import SystemTabs from '../../../../../ui/SystemTabs';

import moment from 'moment';
import 'moment/locale/pt-br';

import { Stack, Button, TextField, MenuItem } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../../../form/tableThemeCustom';
import CustomDialog from '../../../../layout/CustomDialog';

/* hooks */
import { useNavigateParams } from '../../../../../hooks/useNavigateParams';
import { useConfirmDialog } from '../../../../../hooks/useConfirmDialog';
import DocumentosFiscaisDialog from '../modules/distribuicaoFiscal/DocumentosFiscaisDialog';

import { useMRTState } from '../../../../../hooks/useMRTState';

import { normalizarItensXml } from '../../../../../utils/nfe/normalizarItensXml';
import { obterValorTotalComImpostos } from '../../../../../utils/movimento/impostos';

import {
    podeIncluir,
    podeEditar,
    podeCancelar,
    podeImprimir,
    //item do movimento
    podeEditarItem,
    podeCancelarItem,
    podeImprimirItem,
    //relatórios
    podeImprimirAnalitico,
    podeImprimirGerencia,
    podeImprimirSintetico,
} from '../../../../../hooks/usePermisionMRT';

/* utils */
import {
    formatarNumero,
    formatarNumero3Digitos,
    formatarNumeroDecimal,
    formatarNumeroDecimal3Digitos,
    toNumberBR,
} from '../../../../../utils/masks';

import { aplicarDescontoFinanceiroCabecalho } from '../../../../../utils/movimento/descontoFinanceiro';

import { obterValoresByMovimentoItens } from '../../../../../utils/movimento';
import { retornaData } from '../../../../../utils/retornaDataFormatada';
import { obterDesconto, calculaDataVencimento } from '../../../../../utils/financeiro';

import CRUDsAPI from '../../../../../api/CRUDs';
import * as AlmoxarifadoAPI from '../../../../../api/almoxarifado';
import * as DataListAPI from '../../../../../api/dataList';
import * as EmbalagemAPI from '../../../../../api/embalagem';
import * as FinanceiroAPI from '../../../../../api/financeiro';
import * as MovimentoAPI from '../../../../../api/movimento';
import * as PessoaAPI from '../../../../../api/pessoa';
import * as PlantaoAPI from '../../../../../api/plantao';
import * as ProdutoAPI from '../../../../../api/produto';
import * as TabelaAPI from '../../../../../api/tabela';
import * as TabelaPrecoAPI from '../../../../../api/tabelaPreco';
import * as TributacaoAPI from '../../../../../api/tributacao';
import * as VerificadoresAPI from '../../../../../api/verificadores';
import * as UsuarioAPI from '../../../../../api/usuario';
// helpers
import { patchEndereco, resolveParceiroVaiEm } from '../../../../../helpers/helpers';

// boot dos forms
import { applyBoot } from '../boot/index';
import { isNovoCadastro } from '../boot/utils';

import { MOVIMENTO_TABS } from '../../shared/constants';

// hooks
import { useMovimentoTabsConfig } from '../modules/hooks/useMovimentoTabsConfig';
import { useLimiteCentroCustoModule } from '../modules/hooks/useLimiteCentroCustoModule';
import { useItemButtonStateModule } from '../modules/hooks/useItemButtonStateModule';
import { useItemValidationModule } from '../modules/hooks/useItemValidationModule';
import { useItemPrecoDescontoModule } from '../modules/hooks/useItemPrecoDescontoModule';
import { useMovimentoTotaisModule } from '../modules/hooks/useMovimentoTotaisModule';
import { useItemEstoqueModule } from '../modules/hooks/useItemEstoqueModule';

function Form({
    dados,
    setDados,
    handleSubmit,

    btnText,
    natureza,
    //paramêtros
    parametro,
    operacao,
    operacaoParametros,
    operacaoParametrosDocumentos,
    caminhoVoltar,
    //options
    OptionsSituacao,
    OptionsSituacaoItem,

    OptionsCentroCusto,
    OptionsTabelaPreco,
    OptionsEmpresa,

    //funções
    onCarregarTabelaPreco,
    obterTabelaPrecoByOperacaoParametros,

    //enums frete
    enumFreteTipo,
    enumFreteResponsavelFinanceiro,
    //enums locação de imóveis
    enumAgua,
    enumCondominio,
    enumContrato,
    enumDiaVencimento,
    enumEnergia,
    enumIPTU,
    enumTipoAditivo,
    enumLocacao,
    //industria
    dataPlantao,
    //empresas
    pessoaId,
    empresaId,
    empresaIds,

    //fechamento do form
    shouldCloseAfterCreate,
    setShouldCloseAfterCreate,
    indexadores,
    // variável
    modoTabelaPreco,
    centroCustoLimiteBloquearNaDigitacao,
    centroCustoLimiteBloquear,
    setFlashMessage,
}) {
    // hook para evitar duplo click
    const formLock = useActionLock();
    const recalculoVencimentoRef = useRef({ id: 0, pendente: false });

    const [postCreateSyncDone, setPostCreateSyncDone] = useState(false);
    const [assinaturaPendente, setAssinaturaPendente] = useState(null);

    const navigate = useNavigateParams();

    //configura a formatação dos decimais
    const utiliza3digitos = operacaoParametros.utiliza3digitos;
    const casaDecimal = utiliza3digitos ? 3 : 2;

    // parametros para rotina de balanço
    const isBalanco = operacao?.balanco === true || Number(operacao?.balanco) === 1;
    const isNovoBalanco = isBalanco && !dados?.id;
    const isBalancoExistente = isBalanco && !!dados?.id;

    const profile = useMemo(() => {
        return getMovimentoProfile({
            operacao,
            naturezaUrl: natureza,
            operacaoParametros,
        });
    }, [
        natureza,
        operacao?.id,
        operacao?.sigla,
        operacao?.entrada,
        operacao?.saida,
        operacaoParametros?.id,
        operacaoParametros?.formTabelaOrProduto,
    ]);

    //profile simplificação
    const showCabecalho = profile?.uiTabs?.cabecalho?.show;
    const profileParametrosCabecalho = profile?.parametros?.cabecalho;
    const profileParametrosItens = profile?.parametros?.itens || {};

    const urlParams = new URLSearchParams(window.location.search);
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const origem = urlParams.get('origem') || '';

    const params = useMemo(() => {
        return new URLSearchParams({
            ul: ul ?? '',
            li: li ?? '',
            tipo: tipo ?? '',
            operacao: operacaoUUID ?? '',
            uuid: uuid ?? '',
            btnText: btnText ?? '',
            natureza: natureza ?? '',
            origem: origem ?? '',
        });
    }, [ul, li, tipo, operacaoUUID, uuid, btnText, natureza, origem]);

    //distinção entre cliente e fornecedor
    const initialLoadRef = useRef(btnText?.toLowerCase() === 'cadastrar' ? false : true); //rotina para atualizar o parceiro apenas qdo mudar

    ///Atualiza os dados da Empresa
    const empresaArmazenada = JSON.parse(localStorage.getItem('Empresa'));

    //itens das grids
    const [itemLancamentos, setItemLancamentos] = useState([]);
    const [parametroPessoa, setParametroPessoa] = useState({});
    const [lancamentos, setLancamentos] = useState([]);
    const [OptionsAlmoxarifados, setOptionsAlmoxarifado] = useState([]);
    const [itensProdutosView, setItensProdutosView] = useState([]);
    const [itensAssinaturaView, setItensAssinaturaView] = useState([]);

    // padronizar as mensagens
    const dispararMensagens = useCallback(
        (mensagens = []) => {
            mensagens.forEach((mensagem) => {
                if (!mensagem?.texto) return;

                setFlashMessage(
                    mensagem.texto,
                    mensagem.tipo || 'warning',
                    mensagem.tempo || 6,
                    mensagem.msgPosition || 'center'
                );
            });
        },
        [setFlashMessage]
    );

    const consultaFator = useCallback(async (empresaId, embalagemId) => {
        const result = await TabelaAPI.fatorByEmbalagemId(empresaId, embalagemId);
        return result;
    }, []);
    const consultaAlmoxarifados = async (empresaId) => {
        const result = await AlmoxarifadoAPI.almoxarifadosByEmpresaId(empresaId);
        setOptionsAlmoxarifado(result);
        return result;
    };
    async function retornaParametroPessoa() {
        try {
            const resultado = await PessoaAPI.parametroPessoa({ id: pessoaId });
            if (!resultado) {
                return;
            }
            setParametroPessoa(resultado);
            setDados((prev) => ({
                ...prev,
                colaboradorId: resultado.id,
            }));
            setColaborador({
                ...Colaborador,
                descricao: resultado.descricao,
            });
            return resultado;
        } catch (erro) {
            // Lide com o erro
            console.error(erro);
        }
    }
    async function retornaLancamentos(pessoaId, tipo) {
        try {
            const result = await FinanceiroAPI.lancamentosEmAberto(pessoaId, tipo);
            setLancamentos(result);
        } catch (erro) {
            console.error(erro);
        }
    }
    async function retornaParcelas(
        totalParcelas,
        primeiraDataVencimento,
        dadosLancamento,
        credito,
        fixaDiaVencimento,
        diasEntreParcelas,
        valorOriginal,
        valor,
        diaVencimento
    ) {
        try {
            const result = await FinanceiroAPI.calcularParcelas(
                totalParcelas,
                primeiraDataVencimento,
                dadosLancamento,
                credito,
                fixaDiaVencimento,
                diasEntreParcelas,
                valorOriginal,
                valor,
                diaVencimento
            );
            return result;
        } catch (erro) {
            console.error(erro);
        }
    }

    //set datalist
    const [Colaborador, setColaborador] = useState({});
    const [OptionsColaborador, setOptionsColaborador] = useState([]);

    const [Administrador, setAdministrador] = useState({});
    const [OptionsAdministrador, setOptionsAdministrador] = useState([]);

    const [Parceiro, setParceiro] = useState({});
    const [OptionsParceiro, setOptionsParceiro] = useState([]);

    const [ParceiroVinculado, setParceiroVinculado] = useState({});
    const [OptionsParceiroVinculado, setOptionsParceiroVinculado] = useState([]);

    //data and fetching state
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);

    const [rowCountFinanceiro, setRowCountFinanceiro] = useState(0);
    const [rowCountLancamento, setRowCountLancamento] = useState(0);

    const [isDisabledCusto, setIsDisabledCusto] = useState(true);

    //table state
    const {
        columnFilterFns,
        setColumnFilterFnsMode: setColumnFiltersMode, // mantém o nome que você já usa
        columnFilters,
        setColumnFilters,
        globalFilter,
        setGlobalFilter,
        sorting,
        setSorting,
        pagination,
        setPagination,
    } = useMRTState({
        storageKey: 'movimento.mrt', // pode mudar depois
        pageSizeDefault: parametro?.paginacao,
    });
    const mrtItens = useMRTState({
        storageKey: `movimento.${operacao?.sigla || 'default'}.itens`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const mrtAssinatura = useMRTState({
        storageKey: `movimento.${operacao?.sigla || 'default'}.assinatura`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const mrtLancamento = useMRTState({
        storageKey: `movimento.${operacao?.sigla || 'default'}.lancamento`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const mrtFinanceiro = useMRTState({
        storageKey: `movimento.${operacao?.sigla || 'default'}.financeiro`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const mrtFrete = useMRTState({
        storageKey: `movimento.${operacao?.sigla || 'default'}.frete`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const mrtAditivo = useMRTState({
        storageKey: `movimento.${operacao?.sigla || 'default'}.aditivo`,
        pageSizeDefault: parametro?.paginacao || 5,
        pageIndexDefault: 0,
    });
    const mrtDistribuicaoFiscalResumos = useMRTState({
        storageKey: `movimento.${operacao?.sigla || 'default'}.distribuicaoFiscal.resumos`,

        pageSizeDefault: parametro?.paginacao || 20,

        pageIndexDefault: 0,
    });

    const mrtDistribuicaoFiscalDocumentos = useMRTState({
        storageKey: `movimento.${operacao?.sigla || 'default'}.distribuicaoFiscal.documentos`,

        pageSizeDefault: parametro?.paginacao || 20,

        pageIndexDefault: 0,
    });
    // params => empresaId, tabela, id, descricao, condicao, filtro, operacao, funcionarioId
    const consultaDatalist = async (params) => {
        try {
            return await DataListAPI.dataList(params);
        } catch (error) {
            console.error('Erro ao consultar DataList:', error);
            throw error;
        }
    };
    const consultaDatalistColaborador = async ({ empresaId, filtro, ativo, tipo, plantaoId, plantaoTipoId, obrigaPlantao }) => {
        const result = obrigaPlantao
            ? await PlantaoAPI.colaboradoresByPlantao({ empresaId, filtro, ativo, tipo, plantaoId, plantaoTipoId })
            : await DataListAPI.serviceDataListColaboradorOrRepresentante({ empresaId, filtro, ativo, tipo });
        //: await DataListAPI.dataListColaborador({ empresaId, filtro, ativo, tipo });
        return result;
    };
    const consultaDatalistParceiroImoveis = async (
        empresaId,
        filtro,
        locador,
        locatario,
        fiador,
        funcionarioId,
        administrador
    ) => {
        const data = await DataListAPI.dataListParceiroImovel(
            empresaId,
            filtro,
            locador,
            locatario,
            fiador,
            funcionarioId,
            administrador
        );
        return data;
    };
    const consultaTributacao = async (ncmId) => {
        const tributacao = await TributacaoAPI.tributacaoByNCM(ncmId);
        return tributacao;
    };
    async function fetchData(grid, mrtState) {
        // Recarregar aditivos após salvar preserva os filtros e a página da própria grid.
        mrtState = mrtState ?? (grid === 'aditivo' ? mrtAditivo : undefined);
        const currentPagination = mrtState?.pagination ?? pagination;
        const currentColumnFilters = mrtState?.columnFilters ?? columnFilters;
        const currentColumnFilterFns = mrtState?.columnFilterFns ?? columnFilterFns;
        const currentGlobalFilter = mrtState?.globalFilter ?? globalFilter;
        const currentSorting = mrtState?.sorting ?? sorting;

        const offset = currentPagination.pageIndex * currentPagination.pageSize;
        const limit = currentPagination.pageSize;
        // =========================
        // HELPERS (LOCAL)
        // =========================
        const applyLocalFiltersAndSorting = (data = [], globalFilterValue = '', sortingValue = []) => {
            let result = Array.isArray(data) ? data : [];

            // globalFilter simples e seguro (não depende de "name")
            const gf = (globalFilterValue || '').trim()?.toLowerCase();
            if (gf) {
                result = result.filter((row) => JSON.stringify(row)?.toLowerCase().includes(gf));
            }

            // sorting local (bem simples: só funciona se accessorKey existir no row)
            // Se quiser, depois evoluímos para columnDef.accessorFn.
            if (Array.isArray(sortingValue) && sortingValue.length) {
                const s0 = sortingValue[0]; // MRT geralmente manda array; aqui aplico só o primeiro
                const { id, desc } = s0 || {};
                if (id) {
                    result = [...result].sort((a, b) => {
                        const av = a?.[id];
                        const bv = b?.[id];

                        // tenta número
                        const an = Number(av);
                        const bn = Number(bv);
                        const bothNum = Number.isFinite(an) && Number.isFinite(bn);

                        if (bothNum) return desc ? bn - an : an - bn;

                        // fallback string
                        const as = (av ?? '').toString();
                        const bs = (bv ?? '').toString();
                        return desc ? bs.localeCompare(as) : as.localeCompare(bs);
                    });
                }
            }

            return result;
        };

        // =========================
        // LOADING FLAGS
        // =========================
        const hasCache = !!(
            (lancamentos?.length || 0) &&
            (itensProdutos?.length || 0) &&
            (itemLancamentos?.length || 0) &&
            (itensAssinatura?.length || 0)
        );

        setIsError(false);
        setIsLoading(!hasCache);
        setIsRefetching(!!hasCache);

        const commonObj = {
            start: offset,
            size: limit,
            filters: JSON.stringify(currentColumnFilters ?? []),
            filtersMode: JSON.stringify(currentColumnFilterFns ?? {}),
            globalFilter: currentGlobalFilter,
            sorting: JSON.stringify(currentSorting ?? []),
            // campos comuns para listar itens, assinaturas, frete etc
            movimentoId: dados.id,
            // campos para listar itens
            movimentoUuid: dados.uuid,
            operacaoId: dados.operacaoId,
            empresaId: dados.empresaId,
            // campos comuns para listar financeiro
            parceiroId: dados.parceiroId,
            situacaoId: operacaoParametros?.situacaoId ?? 1,
        };

        try {
            // =========================
            // SEM MOVIMENTO (LOCAL)
            // =========================
            if (!dados?.id) {
                if (grid === 'itens') {
                    const filtered = applyLocalFiltersAndSorting(itensProdutos, currentGlobalFilter, currentSorting);
                    setItensProdutosView(filtered);
                    return;
                }

                // assinatura/lancamentos/financeiro não fazem sentido local (por enquanto)
                if (grid === 'assinatura') {
                    const filtered = applyLocalFiltersAndSorting(itensAssinatura, currentGlobalFilter, currentSorting);
                    setItensAssinaturaView(filtered);
                    return;
                }

                return;
            }

            // =========================
            // COM MOVIMENTO (REMOTE)
            // =========================
            if (grid === 'financeiro') {
                const response = await MovimentoAPI.listarFinanceiro(commonObj);

                setLancamentos(response.data.data || []);
                mrtFinanceiro.setRowCount(response.data.meta?.totalRowCount || 0);
                return;
            }

            if (grid === 'itens') {
                const response = await MovimentoAPI.listarProdutosPedido(commonObj);

                // ✅ canônico: módulo assume lista + rowCount + sincroniza dados.movimentoItems
                itensModule.actions.setRemote(response.data.data || [], response.data.meta?.totalRowCount);

                // ✅ em modo remoto, a view local pode ser limpa pra não confundir
                setItensProdutosView([]);
                return;
            }

            if (grid === 'lancamento') {
                const response = await MovimentoAPI.listarLancamentos(commonObj);

                setItemLancamentos(response.data.data || []);
                mrtLancamento.setRowCount(response.data.meta?.totalRowCount || 0);
                return;
            }

            if (grid === 'assinatura') {
                const response = await MovimentoAPI.listarAssinatura(commonObj);

                // ✅ padrão: usar o módulo
                assinaturasModule.actions.setRemote(response.data.data || [], response.data.meta?.totalRowCount || 0);

                // (opcional) se você tiver view local:
                setItensAssinaturaView([]);

                return;
            }

            if (grid === 'frete') {
                const response = await MovimentoAPI.listarFretes(commonObj);
                freteModule.actions.setRemote(response.data.data || [], response.data.meta?.totalRowCount || 0);
                return;
            }

            if (grid === 'aditivo') {
                // ✅ sem movimento: não lista (e nem precisa “local view”)
                if (!dados?.id) return;

                await aditivoModule.actions.refresh(commonObj);
                return;
            }
        } catch (error) {
            setIsError(true);
            console.error(error);
        } finally {
            setIsLoading(false);
            setIsRefetching(false);
        }
    }

    /* Funções para o movimento */
    const handleMovimento = async (movimentoItems) => {
        //obtem o prazo atual
        const prazo = await FinanceiroAPI.buscaPrazoById(dados.prazoId);
        //obtem a quantidade de parcelas do prazo atual
        const totalParcela = prazo?.parcela || 1;

        //inicia o valor total do pedido com 0
        let totalValor = 0;

        if (Array.isArray(movimentoItems)) {
            movimentoItems.forEach((item) => {
                if (item?.pedido === true) {
                    totalValor += obterValorTotalComImpostos(item);
                }
            });
        }

        const valorParcela = Number(totalValor / totalParcela).toFixed(2);

        setDados((prev) => ({
            ...prev,
            Prazo: prazo,
            totalValor: Number(totalValor).toFixed(2) || 0,
            totalParcela: totalValor ? totalParcela : 0,
            valorParcela: totalValor ? valorParcela : 0,
        }));

        return { totalValor, totalParcela, valorParcela };
    };

    //ref para o input de importar itens via XML
    const importarItensXmlRef = useRef(null);

    // ===============================================
    // MÓDULO: CABEÇALHO (headless, states, actions )
    // ===============================================
    const cabecalhoModule = useCabecalhoModule({
        dados,
        setDados,

        operacao,
        operacaoParametros,
        profile,
        setFlashMessage,
        //industria
        dataPlantao,
        Parceiro,
        setParceiro,

        onItensXmlLoaded: (itensXml) => {
            if (typeof importarItensXmlRef.current === 'function') {
                importarItensXmlRef.current(itensXml);
            }
        },
    });

    const {
        change: changeCabecalho,
        aplicarDocumentoFiscal,
        clear: limparCabecalho,
        setRemote: setDadosRemote,
        changeParceiroImovel: changeParceiroImovelAsync,
        changeColaborador: changeColaboradorAsync,
        changeParceiro: changeParceiroAsync,
        verificarParceiroColaborador,
    } = cabecalhoModule.actions;

    // ===============================================
    // MÓDULO: BALANÇO (headless, states, actions )
    // ===============================================
    const balancoModule = useBalancoModule({
        dados,
        setDados,
        enabled: operacao?.balanco === true,
        initialPageSize: Number(parametro?.paginacao) || 50,
        MovimentoAPI,
        setFlashMessage,
        consultaDatalistColaborador,
    });

    // ======================================================
    // MÓDULO: DISTRIBUIÇÃO FISCAL (headless, states, actions)
    // ======================================================
    const distribuicaoFiscalModule = useDistribuicaoFiscalModule({
        empresaId: dados?.empresaId,

        is_cEANTrib: dados?.is_cEANTrib,

        parametro,

        mrtResumos: mrtDistribuicaoFiscalResumos,

        mrtDocumentos: mrtDistribuicaoFiscalDocumentos,

        setFlashMessage,

        onImportarResumo: async (response) => {
            return await aplicarDocumentoFiscal(response);
        },
    });

    // =========================================
    // MÓDULO: ITENS (headless, states, actions)
    // =========================================
    const itensModule = useItensModule({
        dados,
        setDados,

        //parametros
        profile,
        parametro,
        operacao,
        operacaoParametros,
        natureza,
        empresaIds,
        casaDecimal,

        modelKey: 'movimentoItems',

        // APIs
        ProdutoAPI,
        EmbalagemAPI,
        TabelaAPI,
        TabelaPrecoAPI,
        MovimentoAPI,
        DataListAPI,

        // infra UI
        setFlashMessage,

        // formatadores
        formatarNumeroDecimal,
        formatarNumeroDecimal3Digitos,

        indexadores,
        mrt: mrtItens,
        dataPlantao, //informações do plantao;
        changeParceiroAsync,
        changeColaboradorAsync,
        consultaDatalist,
        consultaDatalistColaborador,
        //variáveis
        modoTabelaPreco,
    });
    const { setRemote: setRemoteItens } = itensModule.actions;
    const { draft: novoProduto, setDraft: setNovoProduto, itensProdutos } = itensModule.state;
    const {
        loadFromTabelaPreco,
        //funções
        obterMovimentoItem,
        obterItemTabelaPrecoByItemId,
        reaplicarPrecos,
        reaplicarPrecosDraft,
        reaplicarPrecosLista,
        // pedido padrão
        adicionarItemPedidoPadrao,
        carregarPedidoPadraoNoMovimento,
    } = itensModule.actions;

    // ================================================
    // MÓDULO: ASSINATURAS (headless, states, actions )
    // ================================================
    const assinaturasModule = useAssinaturasModule({
        dados,
        natureza,
        UsuarioAPI,
        MovimentoAPI,
        itensModule,
        setFlashMessage,
        operacaoParametros,
        fetchData,
        mrt: mrtAssinatura,
    });
    const {
        draft: novaAssinatura,
        setDraft: setNovaAssinatura,
        itensAssinatura,
        rowCountAssinatura,
        canSign,
    } = assinaturasModule.state;

    // ==========================================
    // MÓDULO: FRETE (headless, states, actions )
    // ==========================================
    const freteModule = useFreteModule({
        dados,
        setDados,
        natureza,
        CRUDsAPI,
        DataListAPI,
        MovimentoAPI,
        PessoaAPI,
        setFlashMessage,
        formatarNumeroDecimal,
        operacaoParametros,
        mrt: mrtFrete,
        fetchData,
    });

    //============================================
    // Aditivos (headless, states, actions )
    //============================================
    const aditivoModule = useAditivoModule({
        operacao,
        dados,
        setDados,
        MovimentoAPI,
        setFlashMessage,
        fetchData,
        mrt: mrtAditivo,
        enumTipoAditivo,
        getValorAnteriorBase: () => itensModule?.list?.items?.[0]?.valorUnitario || null,
    });

    const podeSalvarItemBase = useMemo(() => {
        const usaTabelaPreco = !!profile?.parametros?.itens?.usaTabelaPreco;

        const valorUnit = novoProduto?.valorUnitario;

        const tabelaOk = usaTabelaPreco ? !!novoProduto?.tabelaPrecoId : true;
        const produtoOk = !!novoProduto?.produtoId;
        const embalagemOk = !!novoProduto?.embalagemId;
        const qtdOk = !!novoProduto?.quantidade && novoProduto?.quantidade > 0;

        const precoOk = valorUnit > 0 || !!operacaoParametros?.ultimoCusto;

        return tabelaOk && produtoOk && embalagemOk && qtdOk && precoOk;
    }, [
        profile,
        novoProduto?.tabelaPrecoId,
        novoProduto?.produtoId,
        novoProduto?.embalagemId,
        novoProduto?.quantidade,
        novoProduto?.valorUnitario,
        operacaoParametros?.ultimoCusto,
    ]);

    //=======================================================
    // pedido padrão
    //=======================================================
    const {
        pedidosPadrao,
        pedidoPadraoLoading,
        carregarPedidosPadrao,
        obterPedidoPadrao,
        salvarComoPedidoPadrao,
        removerPedidoPadrao,
    } = usePedidoPadraoModule({
        dados,
        setFlashMessage,
        // pedido padrão
        adicionarItemPedidoPadrao,
        carregarPedidoPadraoNoMovimento,
    });
    const [pedidoPadraoSelecionadoUuid, setPedidoPadraoSelecionadoUuid] = useState('');
    const [pedidoPadraoOpen, setPedidoPadraoOpen] = useState(false);

    const onAbrirPedidoPadrao = () => {
        setPedidoPadraoOpen(true);
    };

    const onFecharPedidoPadrao = () => {
        setPedidoPadraoOpen(false);
    };
    const [pedidoPadraoDialog, setPedidoPadraoDialog] = useState({
        open: false,
        descricao: '',
        diaSemana: new Date().getDay(),
    });
    const [pedidoPadraoCarregarDialog, setPedidoPadraoCarregarDialog] = useState({
        open: false,
        pedido: null,
    });
    const [pedidoPadraoExcluirDialog, setPedidoPadraoExcluirDialog] = useState({
        open: false,
        pedido: null,
    });

    const handleSalvarPedidoPadrao = () => {
        setPedidoPadraoDialog({
            open: true,
            descricao: '',
            diaSemana: new Date().getDay(),
        });
    };

    const handleConfirmarSalvarPedidoPadrao = async () => {
        if (!pedidoPadraoDialog.descricao?.trim()) {
            setFlashMessage('Informe uma descrição.', 'warning');
            return;
        }

        await salvarComoPedidoPadrao({
            descricao: pedidoPadraoDialog.descricao.trim(),
            diaSemana: pedidoPadraoDialog.diaSemana,
        });

        setPedidoPadraoDialog((prev) => ({
            ...prev,
            open: false,
        }));
    };
    const handleSelecionarPedidoPadrao = async (event) => {
        const uuid = event.target.value;

        setPedidoPadraoSelecionadoUuid(uuid);

        if (!uuid) return;

        const pedido = await obterPedidoPadrao(uuid);

        if (!pedido) return;

        const possuiItens = (dados?.movimentoItems || []).some((item) => {
            return Number(item?.quantidade || 0) > 0 || item?.pedido === true;
        });

        if (!possuiItens) {
            await carregarPedidoPadraoNoMovimento(pedido);
            setPedidoPadraoSelecionadoUuid('');
            return;
        }

        setPedidoPadraoCarregarDialog({
            open: true,
            pedido,
        });
    };
    const handleAbrirExcluirPedidoPadrao = () => {
        const pedido = pedidosPadrao.find((item) => item.uuid === pedidoPadraoSelecionadoUuid);

        if (!pedido) {
            setFlashMessage('Selecione um pedido padrão.', 'warning');
            return;
        }

        setPedidoPadraoExcluirDialog({
            open: true,
            pedido,
        });
    };
    const handleConfirmarExcluirPedidoPadrao = async () => {
        if (!pedidoPadraoExcluirDialog?.pedido?.uuid) return;

        await removerPedidoPadrao(pedidoPadraoExcluirDialog.pedido.uuid);

        setPedidoPadraoSelecionadoUuid('');

        setPedidoPadraoExcluirDialog({
            open: false,
            pedido: null,
        });
    };
    //=======================================================
    // hooks
    //=======================================================
    const movimentoTotaisModule = useMovimentoTotaisModule({
        itensProdutos,
        dados,
        setDados,
        handleMovimento,
    });

    const totalMovimento = movimentoTotaisModule.state.totalValor;

    const limiteCentroCustoModule = useLimiteCentroCustoModule({
        dados,
        setDados,
        novoProduto,
        valorParcelaMovimento: movimentoTotaisModule.state.valorParcela,
        totalValorMovimento: movimentoTotaisModule.state.totalValor,
        operacaoParametros,
        profile,
        centroCustoLimiteBloquear,
        centroCustoLimiteBloquearNaDigitacao,
    });

    const limiteCentroCustoState = limiteCentroCustoModule.state;

    const limites = {
        ...limiteCentroCustoState.limites,
        limiteDisponivel:
            limiteCentroCustoState.limites?.limiteDisponivelAjustado ?? limiteCentroCustoState.limites?.limiteDisponivel ?? 0,
    };

    const itemPrecoDescontoModule = useItemPrecoDescontoModule({
        modoTabelaPreco,
        novoProduto,
        profile,
        operacaoParametros,
        MovimentoAPI,
    });

    const itemEstoqueModule = useItemEstoqueModule({
        dados,
        novoProduto,
        setNovoProduto,
        operacaoParametros,
        MovimentoAPI,
        consultaFator,
    });

    const itemValidationModule = useItemValidationModule({
        novoProduto,
        profile,
        operacaoParametros,
        OptionsEmbalagem: itensModule.state.OptionsEmbalagem,
    });

    const bloquearPorXml = itensProdutos.some((item) => item?.importadoXml && (item.pendenteXml || item.pendente));

    const itemEmEdicao = novoProduto?.index !== null && novoProduto?.index !== undefined;

    const itemButtonsStateModule = useItemButtonStateModule({
        itemValidation: itemValidationModule.state,
        bloqueadoPorLimite: limiteCentroCustoModule.state.bloqueadoPorLimiteItem,
        bloqueadoPorPreco: itemPrecoDescontoModule.state.bloqueadoPorPreco,
        bloqueadoPorDesconto: itemPrecoDescontoModule.state.bloqueadoPorDesconto,
        bloqueadoPorEstoque: itemEstoqueModule.state.bloqueadoPorEstoque,
        bloqueadoPorXml: bloquearPorXml,
        itemSalvando: itensModule?.flags?.isSaving ?? false,
        editandoItem: itemEmEdicao,
        formSalvando: formLock.isLocked,
    });

    /* estados das variávies do modulo */
    const { disabledBtnItem, disabledBtnForm, bloqueioAcaoGlobal, bloqueadoPorXml } = itemButtonsStateModule.state;
    /*  mensagens padronizadas por modulos */
    const mensagensModulos = [
        limiteCentroCustoModule.state.mensagemLimite,
        itemValidationModule.state.mensagemItem,
        itemPrecoDescontoModule.state.mensagemPrecoDesconto,

        itemEstoqueModule.state.mensagemEstoque,
        // comissaoModule.state.mensagemComissao,
    ].filter(Boolean);

    dispararMensagens(mensagensModulos);

    //para importar itens do XML
    useEffect(() => {
        importarItensXmlRef.current = (itensXml = []) => {
            const itensFormatados = normalizarItensXml(itensXml);

            setRemoteItens(itensFormatados, itensFormatados.length);
        };
    }, [setRemoteItens]);

    useEffect(() => {
        if (!dados?.id) return;

        fetchData('financeiro', mrtFinanceiro);
    }, [
        dados?.id,
        mrtFinanceiro.columnFilters,
        mrtFinanceiro.columnFilterFns,
        mrtFinanceiro.globalFilter,
        mrtFinanceiro.pagination?.pageIndex,
        mrtFinanceiro.pagination?.pageSize,
        mrtFinanceiro.sorting,
    ]);

    useEffect(() => {
        if (!dados?.id) return;

        fetchData('lancamento', mrtLancamento);
    }, [
        dados?.id,
        mrtLancamento.columnFilters,
        mrtLancamento.columnFilterFns,
        mrtLancamento.globalFilter,
        mrtLancamento.pagination?.pageIndex,
        mrtLancamento.pagination?.pageSize,
        mrtLancamento.sorting,
    ]);

    useEffect(() => {
        if (!dados?.id) return;

        fetchData('assinatura', mrtAssinatura);
    }, [
        dados?.id,
        mrtAssinatura.columnFilters,
        mrtAssinatura.columnFilterFns,
        mrtAssinatura.globalFilter,
        mrtAssinatura.pagination?.pageIndex,
        mrtAssinatura.pagination?.pageSize,
        mrtAssinatura.sorting,
    ]);
    useEffect(() => {
        if (!dados?.id) return;

        fetchData('frete', mrtFrete);
    }, [
        dados?.id,
        mrtFrete.columnFilters,
        mrtFrete.columnFilterFns,
        mrtFrete.globalFilter,
        mrtFrete.pagination?.pageIndex,
        mrtFrete.pagination?.pageSize,
        mrtFrete.sorting,
    ]);
    useEffect(() => {
        if (!dados?.id) return;

        fetchData('aditivo', mrtAditivo);
    }, [
        dados?.id,
        mrtAditivo.columnFilters,
        mrtAditivo.columnFilterFns,
        mrtAditivo.globalFilter,
        mrtAditivo.pagination?.pageIndex,
        mrtAditivo.pagination?.pageSize,
        mrtAditivo.sorting,
    ]);

    // ✅ Assinar + atualizar grid de assinatura (e itens se necessário)
    const onAssinarMovimentoWrapper = async () => {
        await assinaturasModule.actions.signOrSchedule();
    };
    //para depois da assinatura pendente fechar o form
    useEffect(() => {
        if (!shouldCloseAfterCreate) return;
        if (!dados?.id) return;
        if (assinaturaPendente) return;

        // 🔚 fecha
        navigate(caminhoVoltar, { ul, li, tipo, operacao: operacaoUUID, natureza });

        // ✅ reseta o flag
        setShouldCloseAfterCreate(false);
    }, [
        shouldCloseAfterCreate,
        dados?.id,
        assinaturaPendente,
        navigate,
        caminhoVoltar,
        ul,
        li,
        tipo,
        operacaoUUID,
        natureza,
        setShouldCloseAfterCreate,
    ]);
    const movimentoId = dados?.id ? dados?.id : null;
    //Atualiza Selects
    const [OptionsForma, setForma] = useState([]);
    const [OptionsPrazo, setPrazo] = useState([]);
    const [OptionsConta, setConta] = useState([]);

    //endreços
    const [OptionsUF, setUfs] = useState([]);
    const [OptionsMunicipios, setMUNICIPIO] = useState([]);

    const consultaUF = async () => {
        const uf = await VerificadoresAPI.uf('');
        setUfs(uf);
    };
    const consultaMUNICIPIO = async (ufId, uf, descricao) => {
        const municipio = await VerificadoresAPI.municipio(ufId, uf, descricao);
        setMUNICIPIO(municipio);
    };

    //Consultas no backend
    //tipo, credito, empresaId, descricao, dependente, nivel, formaId
    const consultaForma = async (obj) => {
        if (profile?.financeiroPadrao) return; //quando true obtem o financeiro da operacaoParametro
        const result = await FinanceiroAPI.buscaForma(obj);
        setForma(result);
        return result;
    };
    //tipo, formaId, nivel, prazoId, empresaId, prazoMedio
    const consultaPrazo = async (obj) => {
        if (profile?.financeiroPadrao) return; //quando true obtem o financeiro da operacaoParametro
        const result = await FinanceiroAPI.buscaPrazo(obj);
        setPrazo(result);
        return result;
    };
    const consultaConta = async () => {
        if (profile?.financeiroPadrao) return; //quando true obtem o financeiro da operacaoParametro
        const result = await TabelaAPI.tabela(dados.empresaId, 'Conta', 'descricao');
        setConta(result);
    };
    const consultaTabelaPreco = async ({ empresaId, pessoaId, operacaoId, entrada, liberada, locacao, saida, servico }) => {
        if (!pessoaId) {
            return null;
        }
        const result = await TabelaAPI.precoByPessoaId({
            empresaId,
            pessoaId,
            operacaoId,
            entrada,
            liberada,
            locacao,
            saida,
            servico,
        });
        return result;
    };

    const atualizaDadosParceiro = async (pessoaId, empresaId) => {
        if (!pessoaId) return;

        try {
            const resultado = await PessoaAPI.financeiro(pessoaId, empresaId);

            if (!resultado) return;

            // Atualiza os dados do endereço principal
            if (resultado.pessoaEnderecos) {
                const enderecoPrincipal = resultado.pessoaEnderecos.find((endereco) => endereco.principal === true);

                if (enderecoPrincipal) {
                    const parceiroVaiEm = resolveParceiroVaiEm(profile, natureza);
                    const empresaVaiEm = parceiroVaiEm === 'remetente' ? 'destinatario' : 'remetente';
                    setDados((prevState) => ({
                        ...prevState,

                        // parceiro preenche o lado dele
                        ...patchEndereco(parceiroVaiEm, enderecoPrincipal),

                        // empresa preenche o lado oposto
                        ...patchEndereco(empresaVaiEm, empresaArmazenada),
                    }));
                }
            }

            const usarFornecedor = tipo === 'Pagar' || (tipo === 'Servico' && natureza === 'Entrada');

            const contaId = dados.contaId ?? (usarFornecedor ? resultado?.contaFornecedorId : resultado?.contaClienteId);
            const prazoId = dados.prazoId ?? (usarFornecedor ? resultado?.prazoFornecedorId : resultado?.prazoClienteId);
            const formaId = dados.formaId ?? (usarFornecedor ? resultado?.formaFornecedorId : resultado?.formaClienteId);
            const nivel = usarFornecedor ? resultado?.formaFornecedor?.nivelVenda : resultado?.formaCliente?.nivelVenda;
            const prazoMedio = usarFornecedor
                ? (dados.prazoId ?? resultado?.prazoFornecedor?.prazoMedio)
                : (dados.prazoId ?? resultado?.prazoCliente?.prazoMedio);

            const objForma = {
                tipo: tipo,
                credito: null,
                empresaId: dados.empresaId,
                descricao: null,
                dependente: null,
                nivel: nivel,
                formaId: null,
            };
            const objPrazo = {
                tipo: tipo,
                formaId: formaId,
                nivel: nivel,
                prazoId: null,
                empresaId: dados.empresaId,
                prazoMedio: prazoMedio,
            };
            retornaLancamentos(pessoaId, tipo);

            // Consulta forma de pagamento, se houver nível de venda
            await consultaForma(objForma);

            // Consulta prazo de pagamento
            await consultaPrazo(objPrazo);

            // Atualiza as tabelas de preços liberadas, considerando o parametro do profile default false
            if (!profile?.parametros?.financeiroPadrao) {
                const result = await consultaTabelaPreco({
                    empresaId: dados.empresaId,
                    pessoaId: pessoaId,
                    entrada: natureza === 'Entrada' ? operacao.entrada : false, //para operações de ambiguidade elimina a outra opção
                    saida: natureza === 'Saida' ? operacao.saida : false, //para operações de ambiguidade elimina a outra opção
                    liberada: true,
                });
                onCarregarTabelaPreco(result ? result : []);
            }

            // Atualiza os dados principais do parceiro
            setDados((prevState) => ({
                ...prevState,
                Operacao: operacao,

                formaId: formaId,
                prazoId: prazoId,
                contaId: contaId,
                Parceiro: resultado,
            }));
        } catch (error) {
            console.error('Erro ao atualizar dados do parceiro:', error);
        }
    };

    // -----------------------------
    // Primeria  carga no form
    // -----------------------------
    useEffect(() => {
        if (!isNovoCadastro(uuid)) return;

        const parceiroVaiEm = resolveParceiroVaiEm();
        const empresaVaiEm = parceiroVaiEm === 'remetente' ? 'destinatario' : 'remetente';

        setDados((prev) =>
            applyBoot({
                prev,
                operacao,
                profile,
                patchEndereco,
                empresaVaiEm,
                empresaArmazenada,
                parametro,
                operacaoParametros,
            })
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [operacao]);

    useEffect(() => {
        //boot comum a todas operações
        retornaParametroPessoa(); //set do usuário logado
        consultaAlmoxarifados(empresaIds);
        consultaUF();
        obterTabelaPrecoByOperacaoParametros(operacaoParametros ?? []);

        //operações que obtem dos parametros o parceiro default
        if (profile?.parametros?.parceiroPadrao) {
            if (btnText?.toLowerCase() === 'cadastrar') {
                setDados((prev) => ({
                    ...prev,
                    parceiroId: parametro?.pessoaId,
                    parceiroVinculadoId: parametro?.pessoaId,
                    operacaoId: operacaoParametros.operacaoId,
                    situacaoId: operacaoParametros.situacaoId,
                    formaId: operacaoParametros.lancamentoFormaId,
                    prazoId: operacaoParametros.lancamentoPrazoId,
                    contaId: operacaoParametros.lancamentoContaId,
                    centroCustoId: operacaoParametros.centroCustoId,
                    tabelaPrecoId: operacaoParametros.lancamentoTabelaPrecoId,
                    almoxarifadoId: operacaoParametros.almoxarifadoId ?? prev.almoxarifadoId ?? null,
                }));

                setParceiro((prev) => ({
                    ...prev,
                    id: parametro?.pessoaPadrao?.id,
                    descricao: parametro.pessoaPadrao?.descricao,
                }));
            }

            //carrego o novo produto => vou precisar LIMPARPRODUTOS como se comporta
            setNovoProduto((prev) => ({
                ...prev,
                id: null,
                uuid: null,
                movimentoId: dados.id ?? prev.movimentoId ?? null,
                empresaId: dados.empresaId ?? prev.empresaId ?? null,

                tabelaPrecoId: operacaoParametros?.lancamentoTabelaPrecoId ?? prev.tabelaPrecoId ?? null,
                almoxarifadoId: operacaoParametros?.almoxarifadoId ?? dados.almoxarifadoId ?? prev.almoxarifadoId ?? null,

                Empresa: {},
                Produto: {},
                Embalagem: {},
                movimentoItems: {},
                Operacao: operacao,

                precoUnitario: Number(0).toFixed(2),
                preco: Number(0).toFixed(2),
                custo: Number(0).toFixed(2),
                custoCalculado: Number(0).toFixed(2),

                quantidade: Number(profile?.parametros?.itens?.quantidadePadrao).toFixed(casaDecimal), // evita que o usuario fique repetidas vezes digitando
                valorUnitario: Number(0).toFixed(2),
                precoBase: Number(0).toFixed(2),
                descontoPercentual: Number(0).toFixed(2),
                descontoValor: Number(0).toFixed(2),
                valorTotal: Number(0).toFixed(2),

                natureza,
                conferencia: operacao.conferencia,
                pesavel: false,
                prato: false,
                ativo: true,
                funcao: 'Adicionar',
            }));
        } else {
            consultaConta();
            consultaPrazo({ empresaId });
            consultaForma({ empresaId });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parametro, operacaoParametros]);

    const formKey = dados?.uuid || dados?.id || null;
    useEffect(() => {
        if (!formKey) return;
        setParceiro(dados?.Parceiro ?? {});
        setParceiroVinculado(dados?.ParceiroVinculado ?? {});
        setAdministrador(dados?.Administrador ?? {});
        setColaborador(dados?.Colaborador ?? {});

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formKey]);

    useEffect(() => {
        setNovoProduto((prev) => ({
            ...prev,
            almoxarifadoId: dados.almoxarifadoId ?? null,
        }));
    }, [dados?.almoxarifadoId]);
    useEffect(() => {
        consultaMUNICIPIO(dados.remetenteUF, null, null);
    }, [dados?.remetenteUF]);
    // INDUSTRIA
    //obtem o produto pelo código identificador
    useEffect(() => {
        if (!novoProduto.conferenciaCodigo) {
            return;
        }

        obterMovimentoItem({
            refugo: novoProduto.refugo,
            conferenciaCodigo: novoProduto.conferenciaCodigo,
            empresaId: dados.empresaId,
            operacaoIds: [22],
        }); //22 id da operação conferência
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [novoProduto.conferenciaCodigo, novoProduto.refugo]);
    //LIM apenas
    useEffect(() => {
        setDados((prev) => ({
            ...prev,
            energia: dados.solar ? 'Locador' : 'Locatário',
        }));
    }, [dados.solar]);

    //tabelaPrecoId alterar lista de produtos
    useEffect(() => {
        if (!modoTabelaPreco) return;
        const tabelaPrecoId = novoProduto?.tabelaPrecoId || dados?.tabelaPrecoId || null;
        const pedidoId = dados?.id;
        /**
         * 🔴 SEM TABELA → VOLTA PRO PEDIDO
         */
        if (!tabelaPrecoId) {
            // 🔴 sem tabela

            // edição → volta pro pedido
            if (dados?.id) {
                itensModule.actions.refresh();
                return;
            }

            // novo → limpa
            itensModule.actions.commitList([]);
            itensModule.actions.clear?.({ keepTabelaPrecoId: false });

            return;
        }

        /**
         * 🟢 COM TABELA → CARREGA + MESCLA
         */
        loadFromTabelaPreco(tabelaPrecoId);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [novoProduto?.tabelaPrecoId, dados?.tabelaPrecoId, dados?.id]);

    //locação de imovéis
    useEffect(() => {
        if (operacao?.sigla !== 'LIM') return;
        if (!dados.prazoId) return;

        const fetchPrazoLIM = async () => {
            try {
                const resultado = await FinanceiroAPI.buscaPrazoById(dados.prazoId);
                if (!resultado) return;

                const parcela = resultado.parcela;
                const valorTotal = (parcela * (novoProduto.valorUnitario || 0)).toFixed(2);

                const dataSaida = dados.dataSaida ? moment(dados.dataSaida).format('YYYY-MM-DD HH:mm:ss') : null;

                const isContratoFixo = dados.locacao === 'Comercial' || dados.locacao === 'Residencial';

                const entrada = isContratoFixo
                    ? moment(dados.entrada).startOf('day').format('YYYY-MM-DD 00:00:00')
                    : moment(dados.entrada).format('YYYY-MM-DD HH:mm:ss');

                const saida = isContratoFixo
                    ? moment(dados.entrada).add(parcela, 'months').startOf('day').format('YYYY-MM-DD 00:00:00')
                    : moment(dados.saida).format('YYYY-MM-DD HH:mm:ss');

                setDados((prev) => ({
                    ...prev,
                    Prazo: resultado,
                    dataSaida,
                    entrada,
                    saida,
                }));

                setNovoProduto((prev) => ({
                    ...prev,
                    quantidade: parcela,
                    valorTotal,
                }));
            } catch (error) {
                console.error('Erro ao buscar prazo:', error);
            }
        };

        fetchPrazoLIM();
    }, [dados.prazoId, operacao?.sigla]);

    useEffect(() => {
        if (!dados?.parceiroId) return;

        const executar = async () => {
            const resultado = await verificarParceiroColaborador(dados.parceiroId, dados.empresaId);

            const podeUsarCusto = resultado?.podeUsarCusto === true;

            setIsDisabledCusto(podeUsarCusto);

            // ✅ Na carga inicial da edição, só identifica o parceiro.
            // Não zera custo/custoFilial e não reaplica preço.
            if (initialLoadRef.current) {
                return;
            }

            if (profile?.layout === 'restaurante' && !podeUsarCusto) {
                changeCabecalho({ target: { name: 'custo', type: 'checkbox', checked: false } }, {});
                changeCabecalho({ target: { name: 'custoFilial', type: 'checkbox', checked: false } }, {});

                reaplicarPrecos({ custo: false, custoFilial: false });
            } else {
                reaplicarPrecos({
                    custo: !!dados.custo,
                    custoFilial: !!dados.custoFilial,
                });
            }

            atualizaDadosParceiro(dados.parceiroId, dados.empresaId);
        };

        executar();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dados?.parceiroId]);

    // apenas para gerencia o pedido padrão do parciro
    useEffect(() => {
        if (!dados?.parceiroId || !dados?.empresaId) return;

        carregarPedidosPadrao({
            parceiroId: dados.parceiroId,
            empresaId: dados.empresaId,
        });
    }, [dados?.parceiroId, dados?.empresaId]);

    useEffect(() => {
        if (!operacaoParametros) {
            return;
        }

        setDados((prev) => ({
            ...prev,
            operacaoId: prev.operacaoId ?? operacaoParametros.operacaoId,
            centroCustoId: prev.centroCustoId ?? operacaoParametros.centroCustoId,
            situacaoId: prev.situacaoId ?? operacaoParametros.situacaoId,
            almoxarifadoId: prev.almoxarifadoId ?? operacaoParametros.almoxarifadoId,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [operacaoParametros]);

    //assinatura pendentes para movimento criado
    useEffect(() => {
        // só no form novo: quando acabou de cadastrar e ainda não sincronizou
        if (!dados?.id) return;
        if (postCreateSyncDone) return;

        (async () => {
            // 1) atualiza itens do pedido
            await fetchData('itens', mrtItens);

            // 2) atualiza financeiro
            await fetchData('financeiro', mrtFinanceiro);

            // 3) atualiza lancamentos
            await fetchData('lancamento', mrtLancamento);

            // 4) atualiza assinaturas
            await fetchData('assinatura', mrtAssinatura);

            // pronto, não roda de novo
            setPostCreateSyncDone(true);
        })();
    }, [dados?.id, postCreateSyncDone]);

    //=====================================================================================
    // useEffect nao Carrega Tabela de Preco para o RESTAURANTE/IMÓVEIS
    //=====================================================================================
    useEffect(() => {
        if (!modoTabelaPreco) return;
        if (!novoProduto.tabelaPrecoId || !novoProduto.produtoId || !novoProduto.funcao) return;

        const isAdicionar = novoProduto.funcao?.toLowerCase() === 'adicionar';

        // evita recarregar preço quando o item já veio da tabela/linha
        const jaTemPrecoValido = Number(novoProduto?.valorUnitario || 0) > 0 && Number(novoProduto?.precoBase || 0) > 0;

        if (isAdicionar && !jaTemPrecoValido) {
            obterItemTabelaPrecoByItemId({
                tabelaPrecoId: novoProduto.tabelaPrecoId,
                produtoId: novoProduto.produtoId,
            });
        }
    }, [
        modoTabelaPreco,
        novoProduto.tabelaPrecoId,
        novoProduto.produtoId,
        novoProduto.funcao,
        novoProduto.valorUnitario,
        novoProduto.precoBase,
    ]);

    const dialogAssinatura = useConfirmDialog({
        onConfirm: async (dialogData) => {
            const { payload } = dialogData || {};
            const { row, funcao } = payload || {};

            if (funcao?.toLowerCase() !== 'cancelar' || !row) return;

            const result = await assinaturasModule.actions.remove(row);
            if (!result?.ok) throw result?.error;
        },
        onAfterConfirm: async () => {
            await assinaturasModule.actions.refresh();
        },
    });

    const handleOpenDialogAssinatura = (row) => {
        dialogAssinatura.actions.openDialog({
            title: 'Deletar Assinatura',
            content: 'Você tem certeza?',
            confirmLabel: 'Confirmar',
            confirmColor: 'primary',
            payload: {
                funcao: 'Cancelar',
                row,
            },
        });
    };

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;
        if (name === 'preFinanceiro') {
            if (formLock.isLocked) return;
            setDados((prev) => {
                if (prev.id) return prev;
                const next = { ...prev };
                if (value === undefined) delete next.preFinanceiro;
                else next.preFinanceiro = value;
                return next;
            });
            return;
        }
        // helper local pra pegar id do datalist (mantive seu padrão)
        const getIdByValue = (v) => document.querySelector(`datalist option[value="${v}"]`)?.dataset.id || null;

        // ITENS
        if (name.startsWith('novoProduto.') || name.startsWith('Produto.')) {
            itensModule.actions.change(e);
            return;
        }
        // ASSINATURAS
        if (name.startsWith('novaAssinatura.')) {
            assinaturasModule.actions.change(e);
            return;
        }
        //FRETE
        if (name.startsWith('novoFrete.') || name === 'Transportadora.descricao') {
            freteModule.actions.change(e);
            return;
        }
        // 1️⃣ NOVO ADITIVO
        if (name.startsWith('novoAditivo.')) {
            const campo = name.replace('novoAditivo.', '');

            aditivoModule.actions.change(e);
            return;
        }

        // Cabeçalho: Colaborador datalist
        if (name === 'Administrador.descricao') {
            if (operacao?.balanco === true) {
                await changeColaboradorAsync(value, {
                    empresaId: dados?.empresaId,
                    //tipoColaborador: operacao?.tipoColaborador,
                    consultaFn: consultaDatalistColaborador,

                    // Alimenta a lista apresentada pelo datalist
                    setOptions: setOptionsAdministrador,

                    // Controla o texto apresentado no campo
                    setColaboradorState: setAdministrador,

                    getIdByValue,

                    // Direcionamento específico do balanço
                    targetKey: 'administradorId',
                    objectKey: 'Administrador',
                });

                return;
            }

            // Comportamento original das demais operações
            await changeParceiroImovelAsync(value, {
                empresaId: dados?.empresaId,
                consultaFn: consultaDatalistParceiroImoveis,
                setOptions: setOptionsAdministrador,
                setTextState: setAdministrador,
                getIdByValue,
                targetKey: 'administradorId',
                objectKey: 'Administrador',
                flags: {
                    administrador: true,
                },
            });

            return;
        }

        if (name === 'Colaborador.descricao') {
            await changeColaboradorAsync(value, {
                empresaId: dados?.empresaId,
                tipoColaborador: operacao?.tipoColaborador,
                consultaFn: consultaDatalistColaborador,
                setOptions: setOptionsColaborador,
                setColaboradorState: setColaborador,
                getIdByValue,
            });
            return;
        }

        // Cabeçalho: Parceiro datalist
        if (name === 'Parceiro.descricao') {
            await changeParceiroAsync(value, {
                empresaId: dados?.empresaId,
                consultaFn: consultaDatalist,
                setOptions: setOptionsParceiro,
                setTextState: setParceiro,
                getIdByValue,
                condicao: natureza,
                targetKey: 'parceiroId',
            });
            return;
        }
        if (name === 'ParceiroVinculado.descricao') {
            //consulta específica para imoveis
            if (profile?.id === 'imoveis') {
                await changeParceiroImovelAsync(value, {
                    empresaId: dados?.empresaId,
                    consultaFn: consultaDatalistParceiroImoveis,
                    setOptions: setOptionsParceiroVinculado,
                    setTextState: setParceiroVinculado,
                    getIdByValue,
                    targetKey: 'parceiroVinculadoId',
                    flags: { fiador: profileParametrosCabecalho?.parceiroVinculado?.fiador },
                    objectKey: 'ParceiroVinculado',
                });
                return;
            }
            await changeParceiroAsync(value, {
                empresaId: dados?.empresaId,
                consultaFn: consultaDatalist,
                setOptions: setOptionsParceiroVinculado,
                setTextState: setParceiroVinculado,
                getIdByValue,
                condicao: natureza, //preciso analisar se é tipo ou natureza
                targetKey: 'parceiroVinculadoId',
            });
            return;
        }
        // Reutiliza o cálculo dos Lançamentos somente na troca de forma/prazo.
        if (name === 'formaId' || name === 'prazoId') {
            changeCabecalho(e);
            const idCalculo = ++recalculoVencimentoRef.current.id;
            recalculoVencimentoRef.current.pendente = true;
            const formaId = name === 'formaId' ? value : dados.formaId;
            const prazoId = name === 'prazoId' ? value : dados.prazoId;

            try {
                if (name === 'formaId') {
                    const usarFornecedor = tipo === 'Pagar' || (tipo === 'Servico' && natureza === 'Entrada');
                    const prazoMedio = usarFornecedor
                        ? dados?.Parceiro?.prazoFornecedor?.prazoMedio
                        : dados?.Parceiro?.prazoCliente?.prazoMedio;

                    await consultaPrazo({ tipo, formaId: value, empresaId: dados?.empresaId, prazoMedio });
                }

                // Contratos e parcelas personalizadas conservam seus vencimentos próprios.
                if (
                    idCalculo !== recalculoVencimentoRef.current.id ||
                    operacao?.sigla === 'LIM' ||
                    Object.prototype.hasOwnProperty.call(dados, 'preFinanceiro') ||
                    dados.preFinanceiroConfiguracao != null ||
                    !Number(value) ||
                    !Number(formaId) ||
                    !dados.data
                )
                    return;

                // Na troca da forma, o prazo será escolhido em seguida, como em Lançamentos.
                const condicoes = await calculaDataVencimento(null, dados.data, formaId, name === 'prazoId' ? prazoId : null);
                if (idCalculo !== recalculoVencimentoRef.current.id || !condicoes?.vencimento) return;
                if (!moment(condicoes.vencimento, 'YYYY-MM-DD', true).isValid()) {
                    throw new Error('O cálculo retornou um vencimento inválido. Confira a forma e o prazo selecionados.');
                }

                setDados((prev) => {
                    // Uma resposta antiga não deve sobrescrever outra seleção ou uma data digitada.
                    if (
                        idCalculo !== recalculoVencimentoRef.current.id ||
                        String(prev.formaId ?? '') !== String(formaId ?? '') ||
                        String(prev.prazoId ?? '') !== String(prazoId ?? '') ||
                        prev.data !== dados.data ||
                        prev.empresaId !== dados.empresaId ||
                        prev.id !== dados.id ||
                        prev.primeiraDataVencimento !== dados.primeiraDataVencimento ||
                        Object.prototype.hasOwnProperty.call(prev, 'preFinanceiro') ||
                        prev.preFinanceiroConfiguracao != null
                    )
                        return prev;

                    return { ...prev, primeiraDataVencimento: condicoes.vencimento };
                });
            } catch (error) {
                if (idCalculo === recalculoVencimentoRef.current.id) {
                    setFlashMessage(error?.message || 'Não foi possível recalcular o vencimento.', 'warning');
                }
            } finally {
                if (idCalculo === recalculoVencimentoRef.current.id) recalculoVencimentoRef.current.pendente = false;
            }
            return;
        }

        // CABEÇALHO (default)
        return changeCabecalho(e, {
            onFlagsChanged: (flags, nextCabecalho) => {
                reaplicarPrecos({
                    custo: !!nextCabecalho.custo,
                    custoFilial: !!nextCabecalho.custoFilial,
                });
            },
            onParceiroChanged: async (pessoaId) => {
                await changeParceiroAsync(pessoaId);
            },
        });
    }
    async function handleOnBlur(e) {
        const { name, value } = e.target;

        if (['descontoFinanceiroPercentual', 'descontoFinanceiro'].includes(name)) {
            setDados((prev) =>
                aplicarDescontoFinanceiroCabecalho({
                    name,
                    value,
                    dados: prev,
                })
            );
        }
    }
    async function handleOnFocus(e) {}

    const balancoTemPrevia = Array.isArray(balancoModule?.preview?.items) && balancoModule.preview.items.length > 0;

    const submit = async (e) => {
        e.preventDefault();

        if (recalculoVencimentoRef.current.pendente) {
            setFlashMessage('Aguarde o cálculo do vencimento antes de salvar.', 'warning');
            return;
        }

        // Balanço materializado utiliza somente as ações da própria tab.
        if (isBalancoExistente) {
            setFlashMessage('Utilize as ações disponíveis na aba Balanço.', 'warning');
            return;
        }

        // Abertura de um novo balanço pelo fluxo especializado.
        if (isNovoBalanco) {
            if (!dados?.almoxarifadoId) {
                setFlashMessage('Selecione o almoxarifado no cabeçalho.', 'warning');
                return;
            }

            if (!balancoTemPrevia) {
                setFlashMessage('Consulte os produtos antes de abrir o balanço.', 'warning');
                return;
            }

            const configuracao = dados.configuracaoBalanco || {};
            const descricao = String(configuracao.descricao || '').trim();

            const configuracaoBalanco = {
                almoxarifadoId: dados.almoxarifadoId,
                categoria: configuracao.categoria || 'produto',
                filters: JSON.stringify(descricao ? [{ id: 'descricao', value: descricao }] : []),
                filtersMode: JSON.stringify(descricao ? { descricao: 'startsWith' } : {}),
                sorting: JSON.stringify([{ id: 'descricao', desc: false }]),
                contadorPadraoId: configuracao.contadorPadraoId || dados.parceiroId,
                conferentePadraoId: configuracao.conferentePadraoId || dados.colaboradorId,
            };

            await formLock.run(async () => {
                await handleSubmit({
                    ...dados,
                    configuracaoBalanco,
                });
            });

            return;
        }

        // A partir daqui permanece somente o fluxo dos movimentos comuns.
        if (!itemButtonsStateModule.state.disabledBtnItem) {
            setFlashMessage('Finalize o item antes de salvar o movimento.', 'warning');
            return;
        }

        const payload = {
            ...dados,
            movimentoItems: Array.isArray(itensModule?.list?.items) ? itensModule.list.items : [],
            operacao,
            operacaoParametros,
        };

        const exigeItem = operacaoParametros?.exigeItem;
        const itens = payload.movimentoItems || [];
        let mensagem = '';

        if (!Number(payload.parceiroId)) {
            mensagem += 'Parceiro é obrigatório! ';
        }

        if (exigeItem && itens.length === 0) {
            mensagem += 'Não é permitido gravar movimento sem itens! ';
        }

        if (mensagem) {
            setFlashMessage(mensagem, 'warning');
            return;
        }

        await formLock.run(async () => {
            await handleSubmit(payload);
        });
    };

    /* modo tema */
    const theme = tableThemeCustom();

    const { tabsConfigFinal, initialTabKey, onTabChange } = useMovimentoTabsConfig({
        preFinanceiroBloqueado: formLock.isLocked || bloqueioAcaoGlobal || !disabledBtnItem,
        profile,
        dados,
        operacao,
        parametro,
        operacaoParametros,
        operacaoParametrosDocumentos,
        natureza,
        btnText,

        theme,

        // modules
        balancoModule,
        distribuicaoFiscalModule,
        itensModule,
        assinaturasModule,
        freteModule,
        aditivoModule,

        // states
        parametroPessoa,
        Colaborador,
        Parceiro,
        Administrador,
        ParceiroVinculado,

        // options
        OptionsParceiro,
        OptionsColaborador,
        OptionsAdministrador,
        OptionsParceiroVinculado,
        OptionsSituacao,
        OptionsCentroCusto,
        OptionsTabelaPreco,
        OptionsEmpresa,
        OptionsUF,
        OptionsMunicipios,
        OptionsAlmoxarifados,
        OptionsForma,
        OptionsPrazo,
        OptionsConta,
        OptionsSituacaoItem,

        // handlers
        handleChange,
        handleOnFocus,
        handleOnBlur,

        // flags
        isError,
        isLoading,
        isRefetching,

        // MRT
        columnFilterFns,
        columnFilters,
        globalFilter,
        pagination,
        sorting,
        setColumnFilters,
        setColumnFiltersMode,
        setGlobalFilter,
        setPagination,
        setSorting,

        mrtFinanceiro,
        mrtLancamento,

        // extras
        casaDecimal,
        utiliza3digitos,
        formatarNumero,
        formatarNumero3Digitos,

        // perms
        podeIncluir,
        podeEditar,
        podeCancelar,
        podeImprimir,
        podeEditarItem,
        podeCancelarItem,
        podeImprimirItem,

        isDisabledCusto,
        disabledBtnItem,
        limites,
        centroCustoLimiteBloquear,

        enumFreteTipo,
        enumFreteResponsavelFinanceiro,
        enumTipoAditivo,

        //enum de locação
        enumDiaVencimento,
        enumCondominio,
        enumContrato,
        enumEnergia,
        enumAgua,
        enumLocacao,
        enumTipoAditivo,
        enumIPTU,

        navigate,

        handleOpenDialogAssinatura,

        lancamentos,
        rowCountFinanceiro,
        itemLancamentos,
        rowCountLancamento,
        retornaData,

        pedidosPadrao,
        pedidoPadraoLoading,
        onAbrirPedidoPadrao,
        handleSelecionarPedidoPadrao,
        pedidoPadraoSelecionadoUuid,
        handleSalvarPedidoPadrao,
        handleAbrirExcluirPedidoPadrao,
        setFlashMessage,
    });

    return (
        <div>
            <div>
                {/* Modal de Exclusão */}
                {dialogAssinatura.state.open && (
                    <CustomDialog
                        open={dialogAssinatura.state.open}
                        title={dialogAssinatura.state.dialogData.title}
                        content={dialogAssinatura.state.dialogData.content}
                        onClose={dialogAssinatura.actions.closeDialog}
                        onConfirm={dialogAssinatura.actions.confirmDialog}
                        disableConfirm={dialogAssinatura.state.dialogData.disableConfirm}
                        loading={dialogAssinatura.state.loading}
                        confirmLabel={dialogAssinatura.state.dialogData.confirmLabel}
                        confirmColor={dialogAssinatura.state.dialogData.confirmColor}
                    />
                )}
                {/* Modal Pedido Padrão */}
                {pedidoPadraoDialog.open && (
                    <CustomDialog
                        open={pedidoPadraoDialog.open}
                        title="Salvar Pedido Padrão"
                        content={
                            <Stack spacing={2}>
                                <TextField
                                    label="Descrição"
                                    value={pedidoPadraoDialog.descricao}
                                    onChange={(e) =>
                                        setPedidoPadraoDialog((prev) => ({
                                            ...prev,
                                            descricao: e.target.value,
                                        }))
                                    }
                                    fullWidth
                                    autoFocus
                                />

                                <TextField
                                    select
                                    label="Dia da Semana"
                                    value={pedidoPadraoDialog.diaSemana}
                                    onChange={(e) =>
                                        setPedidoPadraoDialog((prev) => ({
                                            ...prev,
                                            diaSemana: Number(e.target.value),
                                        }))
                                    }
                                    fullWidth
                                >
                                    <MenuItem value={0}>Domingo</MenuItem>
                                    <MenuItem value={1}>Segunda</MenuItem>
                                    <MenuItem value={2}>Terça</MenuItem>
                                    <MenuItem value={3}>Quarta</MenuItem>
                                    <MenuItem value={4}>Quinta</MenuItem>
                                    <MenuItem value={5}>Sexta</MenuItem>
                                    <MenuItem value={6}>Sábado</MenuItem>
                                </TextField>
                            </Stack>
                        }
                        onClose={() =>
                            setPedidoPadraoDialog((prev) => ({
                                ...prev,
                                open: false,
                            }))
                        }
                        onConfirm={handleConfirmarSalvarPedidoPadrao}
                        confirmLabel="Salvar"
                        confirmColor="primary"
                    />
                )}

                {pedidoPadraoCarregarDialog.open && (
                    <Dialog
                        open={pedidoPadraoCarregarDialog.open}
                        onClose={() =>
                            setPedidoPadraoCarregarDialog({
                                open: false,
                                pedido: null,
                            })
                        }
                    >
                        <DialogTitle>Carregar Pedido Padrão</DialogTitle>

                        <DialogContent>
                            O pedido atual já possui itens.
                            <br />
                            Deseja adicionar os itens do pedido padrão ou substituir os existentes?
                        </DialogContent>

                        <DialogActions>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() =>
                                    setPedidoPadraoCarregarDialog({
                                        open: false,
                                        pedido: null,
                                    })
                                }
                            >
                                Cancelar
                            </Button>

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    await carregarPedidoPadraoNoMovimento(pedidoPadraoCarregarDialog.pedido, {
                                        substituir: false,
                                    });

                                    setPedidoPadraoCarregarDialog({
                                        open: false,
                                        pedido: null,
                                    });
                                }}
                            >
                                Adicionar
                            </Button>

                            <Button
                                variant="contained"
                                color="warning"
                                onClick={async () => {
                                    await carregarPedidoPadraoNoMovimento(pedidoPadraoCarregarDialog.pedido, {
                                        substituir: true,
                                    });

                                    setPedidoPadraoCarregarDialog({
                                        open: false,
                                        pedido: null,
                                    });
                                }}
                            >
                                Substituir
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}

                {pedidoPadraoExcluirDialog.open && (
                    <CustomDialog
                        open={pedidoPadraoExcluirDialog.open}
                        title="Excluir Pedido Padrão"
                        content={
                            <>
                                Deseja realmente excluir o pedido padrão:
                                <br />
                                <strong>{pedidoPadraoExcluirDialog?.pedido?.descricao}</strong>?
                            </>
                        }
                        onClose={() =>
                            setPedidoPadraoExcluirDialog({
                                open: false,
                                pedido: null,
                            })
                        }
                        onConfirm={handleConfirmarExcluirPedidoPadrao}
                        confirmLabel="Excluir"
                        confirmColor="error"
                    />
                )}

                {distribuicaoFiscalModule.state.open && (
                    <DocumentosFiscaisDialog module={distribuicaoFiscalModule} theme={theme} />
                )}
            </div>{' '}
            <form onSubmit={submit}>
                {dados?.contador && <h5>{'Contador Nº ' + dados?.contador}</h5>}
                <h1>{operacao?.descricao + ' - ' + operacao?.sigla}</h1>

                <SystemTabs tabs={tabsConfigFinal} onTabChange={onTabChange} initialKey={initialTabKey} />

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '1rem',
                        flexWrap: 'wrap', // Permite que os itens quebrem a linha quando necessário
                        justifyContent: 'space-between', // Distribui os itens igualmente
                    }}
                >
                    <Stack direction="row" spacing={1}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => navigate(caminhoVoltar, params)}
                            style={{
                                marginLeft: '10px',
                                minWidth: '120px',
                                fontSize: '14px',
                                '@media (max-width: 600px)': {
                                    fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                    padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                },
                            }}
                            disabled={bloqueioAcaoGlobal || !disabledBtnItem}
                        >
                            Voltar
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="success"
                            style={{
                                marginLeft: '10px',
                                minWidth: '120px',
                                fontSize: '14px',
                                '@media (max-width: 600px)': {
                                    fontSize: '12px', // Ajusta o tamanho da fonte em telas menores
                                    padding: '8px 12px', // Ajusta o padding para manter o botão visível
                                },
                            }}
                            disabled={
                                bloqueioAcaoGlobal ||
                                disabledBtnForm ||
                                !disabledBtnItem ||
                                bloqueadoPorXml ||
                                isBalancoExistente ||
                                (isNovoBalanco && !balancoTemPrevia)
                            }
                        >
                            {isNovoBalanco ? 'Abrir balanço' : btnText}
                        </Button>
                    </Stack>
                </div>
            </form>
        </div>
    );
}
export default Form;
